export default __webpack_public_path__ + "static/media/internshipImg.d26cd0ab.png";